import isEmpty from 'lodash/isEmpty';
import MediaService from '../services/MediaService';

export default function useFileUploader(url: string, bucketName: string) {
  if (isEmpty(url) || isEmpty(bucketName)) {
    throw new Error('Missing url or bucketName');
  }

  const mediaService = new MediaService(url, bucketName);

  async function uploadFiles(medias: any[]) {
    const uploadedUrls = await mediaService.uploadFiles(medias, 'Failed to upload files');
    return uploadedUrls.map((url, index) => {
      const media = medias[index];
      const file = media.file || media;

      return {
        fileKey: url as string,
        caption: `Uploaded at ${new Date().toLocaleString()}`,
        filename: file.name,
        fileType: file.type,
      };
    });
  }

  return {
    uploadFiles,
  };
}
